import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import styled from 'types/theme.types';

// The antd glyph at the shared 16px icon size, on the icon tokens, like popup-entity's trash.
const EditIcon: React.FC<React.SVGProps<SVGSVGElement> & { 'data-e2e'?: string }> = props => {
  // Spread, not a hand-picked four: most call sites wrap this in a Tooltip, and antd opens one by
  // cloning its child with onMouseEnter/onMouseLeave. Naming the props it forwards would drop those and
  // keep every edit tooltip shut.
  return <StyledEditOutlined {...(props as React.ComponentProps<typeof StyledEditOutlined>)} />;
};

const StyledEditOutlined = styled(EditOutlined)`
  font-size: var(--scale-500);
  color: var(--icon-primary-standalone);
  transition: color 200ms ease-in;
  cursor: pointer;

  &:hover {
    color: var(--icon-primary-hover);
  }
`;

export default EditIcon;
